import {
  TransactionEventObject,
  CheckoutEventObject,
  DataLayerObject,
  BookingCompletedEventObject,
  FilterCityEventObject,
  FilterTreatmentEventObject,
  FilterClinicEventObject,
  FilterAppointmentEventObject,
  BookingSummaryEventObject,
  BookingContactInfoEventObject,
  BookingConfirmationEventObject,
  RescheduleExternalBookingEventObject,
  BlockFingerprintEventObject,
  BookingFailedEventObject,
  PhoneNumberClickedEventObject,
  WidgetDisplayedEventObject,
  LoadTokenizationScreenEventObject,
  TokenizationErrorEventObject,
  TokenizationCancelEventObject,
  TokenizationCompleteEventObject,
  ChooseUpcomingBookingObject,
  ChoosePreviousBookingObject,
  ChangeMyBookingClickedObject,
  CancelMyBookingClickedObject,
} from '../models/types'
import { store } from '../store'
import { rudderAnalytics } from './rudderstack'

export const pushToDataLayer = (obj: DataLayerObject) => {
  try {
    const hostWindow = window.parent

    hostWindow.dataLayer = hostWindow.dataLayer || []
    hostWindow.dataLayer.push(obj)
  } catch {
    // Do nothing
  }
}

export const trackRudderstackEvents = (obj: DataLayerObject) => {
  const { event, ...data } = obj
  const state = store.getState()

  const commonProperties = {
    mode: state.app.mode,
    integrationType: state.app.integrationType,
    bookingFlow: state.bookingFlowState.isRebooking
      ? 'my-bookings'
      : 'new-booking',
  }

  const properties = Object.entries(data).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: value,
    }),
    {}
  )
  const newProperties = {
    ...properties,
    ...commonProperties,
  }

  rudderAnalytics.track(event, newProperties)
}

export const bookingFormLoaded = (message: CheckoutEventObject) => {
  trackRudderstackEvents(message)
  pushToDataLayer(message)
}

export const bookingContactInfo = (message: TransactionEventObject) => {
  trackRudderstackEvents(message)
  pushToDataLayer(message)
}

export const bookingComplete = (message: BookingCompletedEventObject) => {
  trackRudderstackEvents(message)
  pushToDataLayer(message)
}

export const bookingFailed = (message: BookingFailedEventObject) => {
  trackRudderstackEvents(message)
}

export const filterByCity = (message: FilterCityEventObject) => {
  trackRudderstackEvents(message)
}

export const filterByTreatment = (message: FilterTreatmentEventObject) => {
  trackRudderstackEvents(message)
}

export const filterByClinic = (message: FilterClinicEventObject) => {
  trackRudderstackEvents(message)
}

export const filterByAppointment = (message: FilterAppointmentEventObject) => {
  trackRudderstackEvents(message)
}

export const bookingSummary = (message: BookingSummaryEventObject) => {
  trackRudderstackEvents(message)
}

export const bookingInfo = (message: BookingContactInfoEventObject) => {
  trackRudderstackEvents(message)
}

export const blockFingerprint = (message: BlockFingerprintEventObject) => {
  trackRudderstackEvents(message)
}

export const rescheduleBooking = (
  message: RescheduleExternalBookingEventObject
) => {
  trackRudderstackEvents(message)
}

export const bookingConfirmation = (
  message: BookingConfirmationEventObject
) => {
  trackRudderstackEvents(message)
}

export const phoneNumberClicked = (message: PhoneNumberClickedEventObject) => {
  trackRudderstackEvents(message)
}

export const widgetDisplayed = (message: WidgetDisplayedEventObject) => {
  trackRudderstackEvents(message)
}

export const loadTokenizationScreen = (
  message: LoadTokenizationScreenEventObject
) => {
  trackRudderstackEvents(message)
}

export const tokenizationError = (message: TokenizationErrorEventObject) => {
  trackRudderstackEvents(message)
}

export const tokenizationCancel = (message: TokenizationCancelEventObject) => {
  trackRudderstackEvents(message)
}

export const tokenizationComplete = (
  message: TokenizationCompleteEventObject
) => {
  trackRudderstackEvents(message)
}

export const chooseUpcomingBooking = (message: ChooseUpcomingBookingObject) => {
  trackRudderstackEvents(message)
}

export const choosePreviousBooking = (message: ChoosePreviousBookingObject) => {
  trackRudderstackEvents(message)
}

export const changeMyBookingClicked = (
  message: ChangeMyBookingClickedObject
) => {
  trackRudderstackEvents(message)
}

export const cancelMyBookingClicked = (
  message: CancelMyBookingClickedObject
) => {
  trackRudderstackEvents(message)
}
